import React from 'react'
import { T } from '@transifex/react'
import { Button } from '@lightspeed/design-system-react'
import { ApiRetailerPaymentType } from '@vend/types'
import { SaleStatus } from '../../../models/sale.constants'
import { SystemPaymentType } from './hooks/useFetchPaymentTypes'
import { useCustomerPaymentOptions } from './hooks/useCustomerPaymentOptions'

type LaybyOnAccountSale = (
  status: SaleStatus.LAYBY_SALE | SaleStatus.ACCOUNT_SALE
) => Promise<void>
export type CustomerPaymentOptionsProps = {
  systemPaymentTypes: SystemPaymentType
  pay: (paymentType: ApiRetailerPaymentType) => void
  laybyOnAccountSale: LaybyOnAccountSale
  isLoyaltyPaymentDisabled: boolean
  isStoreCreditPaymentDisabled: boolean
}

/**
 * Customer Payment Options component for payment panel
 */
export const CustomerPaymentOptions = (props: CustomerPaymentOptionsProps) => {
  const {
    isLoyaltyPaymentDisabled,
    isStoreCreditPaymentDisabled,
    systemPaymentTypes,
    pay,
    laybyOnAccountSale,
  } = props
  const {
    paymentOptions,
    isStoreCreditAndLoyaltyPaymentUnable,
  } = useCustomerPaymentOptions({ systemPaymentTypes, pay, laybyOnAccountSale })

  return (
    <div
      id="confirmed-payment-options-group"
      className="payment-type-button-group vd-btn-group vd-mt5"
    >
      {isStoreCreditAndLoyaltyPaymentUnable && (
        <div className="payment-offline-message vd-ml1 vd-text--sub">
          <span className="vd-i vd-i-wifi-out vd-mr1">
            <T
              _str="You’re currently offline and unable to process this sale with some payment methods."
              _context="Text message for not able to process some payment methods"
            ></T>
          </span>
        </div>
      )}
      {paymentOptions.map(({ id, isDisabled, action, label }) => {
        let isPaymentDisabled = isDisabled
        if (id === 'loyalty') {
          isPaymentDisabled = isLoyaltyPaymentDisabled
        } else if (id === 'storeCredit') {
          isPaymentDisabled = isStoreCreditPaymentDisabled
        }
        return (
          <Button
            key={id}
            className="vd-btn vd-btn--supplementary vd-btn--jumbo btn--payment-type"
            disabled={isPaymentDisabled}
            onClick={action}
            variant="supplementary"
          >
            {label}
          </Button>
        )
      })}
    </div>
  )
}
